import { render } from "./ContentsTextWrap.vue?vue&type=template&id=7944a9c8&scoped=true"
import script from "./ContentsTextWrap.vue?vue&type=script&lang=js"
export * from "./ContentsTextWrap.vue?vue&type=script&lang=js"

import "./ContentsTextWrap.vue?vue&type=style&index=0&id=7944a9c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7944a9c8"]])

export default __exports__